import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./MentionsLegalesPage.module.scss"; // Assicurati di avere un file SCSS corrispondente

import Footer from '../../components/Footer/Footer';

const MentionsLegalesPage_It = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <h1>Note Legali</h1>

        <hr />
        <section>
          <h2>1. Editore del sito web / applicazione</h2>
          <p><strong>Nome dell'azienda o dell'editore:</strong> Hatanna Éditions (Micro), rappresentata dalla Sig.ra Célia Barbier.</p>
          <p><strong>Sede legale:</strong> 173 Bd National 84400 APT</p>
          <p><strong>Numero di registrazione (SIREN):</strong> 832486237</p>
          <p><strong>Email di contatto:</strong> <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a></p>
        </section>

        <section>
          <h2>2. Hosting</h2>
          <p><strong>Nome del provider di hosting:</strong> OVH RCS Roubaix – Tourcoing 424 761 419 00045 Codice APE 6202A</p>
          <p><strong>Indirizzo:</strong> 2 rue Kellermann - 59100 Roubaix - Francia</p>
        </section>

        <section>
          <h2>3. Proprietà intellettuale</h2>
          <p>
            Tutti i contenuti presenti nell'applicazione (testi, immagini, video, codici sorgente, design, logo...)
            sono protetti dalla legge sulla proprietà intellettuale. Qualsiasi riproduzione, distribuzione o modifica
            senza autorizzazione preventiva è vietata e può comportare conseguenze legali.
          </p>
        </section>

        <section>
          <h2>4. Dati personali e privacy</h2>
          <p>
            I dati raccolti tramite l'applicazione vengono trattati in conformità con la nostra
            <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer"> politica sulla privacy</a>.
            In conformità con il <strong>Regolamento Generale sulla Protezione dei Dati (GDPR)</strong>, hai il diritto
            di accedere, correggere e cancellare i tuoi dati personali contattandoci a: [Email di contatto].
          </p>
        </section>

        <section>
          <h2>5. Responsabilità</h2>
          <p>
            L'editore dell'applicazione non può essere ritenuto responsabile per:
          </p>
          <ul>
            <li>Interruzioni temporanee del servizio dovute a operazioni di manutenzione.</li>
            <li>Errori o omissioni nei contenuti visualizzati.</li>
            <li>Danni legati all'uso dell'applicazione da parte dell'utente.</li>
          </ul>
        </section>

        <section>
          <h2>6. Collegamenti ipertestuali</h2>
          <p>
            L'applicazione può contenere collegamenti a siti web di terze parti. L'editore declina ogni responsabilità
            per il contenuto di questi siti e per eventuali conseguenze derivanti dal loro utilizzo.
          </p>
        </section>

        <section>
          <h2>7. Legge applicabile</h2>
          <p>
            Le presenti note legali sono regolate dalla legge francese (o da un'altra giurisdizione applicabile in base al tuo paese).
            In caso di controversia, i tribunali competenti saranno quelli della sede legale dell'editore.
          </p>
        </section>

        <section>
          <h2>8. Sviluppo</h2>
          <p>
            Questa applicazione è stata sviluppata da <strong>Scriptales SAS</strong>
            (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">https://scriptales.fr</a>).
          </p>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default MentionsLegalesPage_It;
